import { usePaldockTranslation } from "hooks/usePaldockTranslation";
import { useCallback } from "react";
import { FormFieldTypes } from "types/enums";

const FORM_FIELD_TYPE_KEY: Record<FormFieldTypes, string> = {
    [FormFieldTypes.Text]: "text",
    [FormFieldTypes.LongText]: "long_text",
    [FormFieldTypes.Number]: "number",
    [FormFieldTypes.Phone]: "phone",
    [FormFieldTypes.Email]: "email",
    [FormFieldTypes.Date]: "date",
    [FormFieldTypes.Country]: "country",
    [FormFieldTypes.Currency]: "currency",
    [FormFieldTypes.FinType]: "fin_type",
    [FormFieldTypes.Checkbox]: "checkbox",
    [FormFieldTypes.CheckboxAccordeon]: "checkbox_accordeon",
    [FormFieldTypes.Select]: "select",
    [FormFieldTypes.MultiSelect]: "multi_select",
    [FormFieldTypes.Radio]: "radio",
    [FormFieldTypes.MultiRadio]: "multi_radio",
    [FormFieldTypes.TagInput]: "tag_input",
    [FormFieldTypes.ListInput]: "list_input",
    [FormFieldTypes.DelimitedInput]: "delimited_input",
    [FormFieldTypes.Range]: "range",
    [FormFieldTypes.Item]: "item",
    [FormFieldTypes.Asset]: "asset",
};

export const useFormFieldTypeLabel = () => {
    const { t } = usePaldockTranslation("enums.form-field-types");

    return useCallback(
        (type: FormFieldTypes | string | null | undefined): string => {
            if (!type) return "";
            const key = FORM_FIELD_TYPE_KEY[type as FormFieldTypes];
            return key ? t(key) : String(type);
        },
        [t]
    );
};
